import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DataTable from "examples/Tables/DataTable";
import Swal from "sweetalert2";
import Api from "../../api/api";

const CategoryTable = ({ refreshTrigger }) => {
  const [userData, setUserData] = useState({ columns: [], rows: [] });
  const navigate = useNavigate();
  const location = useLocation();

  const fetchCategoryData = async () => {
    try {
      const categories = await Api.fetchCategories();

      const columns = [
        { Header: "ID", accessor: "id", width: "10%", align: "left" },
        { Header: "Name", accessor: "name", align: "left" },
        { Header: "Icon", accessor: "icon", align: "left" },
        { Header: "Status", accessor: "status", align: "center" },
        { Header: "Action", accessor: "action", align: "center" },
      ];

      const rows = categories.map((category, index) => ({
        id: index + 1,
        name: category.name,
        icon: (
          <img
            src={`https://iot.papayacoders.in/storage/app/public/${category.icon}`}
            alt={category.name}
            style={{
              width: "40px",
              height: "40px",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        ),
        status: (
          <span style={{ color: Number(category.status) === 1 ? "green" : "red" }}>
            {Number(category.status) === 1 ? "Active" : "Inactive"}
          </span>
        ),
        action: (
          <div style={{ display: "flex", gap: "15px", justifyContent: "center" }}>
            <button
              onClick={() => handleEdit(category)}
              style={{
                color: "#7b809a",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontWeight: "500",
              }}

            >
              Update Status
            </button>
            <button
              onClick={() => handleDelete(category.id)}
              style={{
                color: "#dc3545",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontWeight: "500",
              }}

            >
              Delete
            </button>
          </div>
        ),
      }));

      setUserData({ columns, rows });
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleEdit = (category) => {
    navigate(`/editstatus/${category.id}`, { state: category });
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This category will be deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        await Api.deleteCategories(id);
        Swal.fire("Deleted!", "Category has been deleted.", "success");
        fetchCategoryData();
      } catch (err) {
        console.error("Delete error:", err);
        Swal.fire("Error", "Something went wrong.", "error");
      }
    }
  };

  useEffect(() => {
    fetchCategoryData();
  }, [refreshTrigger]);

  return (
    <DataTable
      table={userData}
      entriesPerPage={{ defaultValue: 5, entries: [5, 10, 15] }}
      canSearch
      showTotalEntries
      isSorted={false}
    />
  );
};

export default CategoryTable;
